import styles from '../style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect, HorizontalSelect, StudentCard, testClass } from 'omni-common-ui';
import { actions as GroupMembers } from 'data/GroupMembers';
import { List } from 'immutable';
import {
  accessors as idpAccessors,
} from 'data/IndividualDevelopmentPlans';
import { actions as UiState } from 'data/UiState';

class StudentSelect extends PureComponent {

  constructor() {
    super();
    this._getLinkHrefForValue = (studentId) =>
      this.props.buildRoute({ studentId, mode: '' });
  }

  componentWillMount() {
    this._buildStudentSelectOptions(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.membersInCurrentIdp !== nextProps.membersInCurrentIdp) {
      this._buildStudentSelectOptions(nextProps);
    }
  }

  _buildStudentSelectOptions(props) {
    // set and cache horizontalselect options (it's pure!)
    const { membersInCurrentIdp } = props;
    if (membersInCurrentIdp.size > 0) {
      // cache this - do not recreate each time
      this._studentSelectOptions = membersInCurrentIdp.map((option) => {
        const { studentGeneralInfo } = option;
        const optionHtml = <StudentCard className={testClass('student-card')} vertical borderless backgroundless>
          <StudentCard.Profile name={studentGeneralInfo.firstName}
              surname={studentGeneralInfo.lastName}
              localName={studentGeneralInfo.localName}
              avatarUrl={studentGeneralInfo.avatarUrl}
              gender={studentGeneralInfo.gender} />
        </StudentCard>;
        return {
          html: optionHtml,
          value: studentGeneralInfo.id,
        };
      }).toArray();
    }
  }

  render() {
    const { membersInCurrentIdp, currentMember, shouldHide } = this.props;
    if (currentMember && membersInCurrentIdp.size && membersInCurrentIdp.size > 0) {
      return <div className={styles.IndividualDevelopmentPlan_studentHorizontalSelect}>
        <HorizontalSelect options={this._studentSelectOptions}
            value={currentMember && currentMember.studentGeneralInfo.id}
            isHide={shouldHide}
            getLinkHrefForValue={this._getLinkHrefForValue} />
      </div>;
    }
    return null;
  }

}

function mapStateToProps(state, ownProps) {
  const { groupId, groupIdpId, studentId } = ownProps.params;
  const groupIdpList = idpAccessors.getGroupIdpList(state, groupId);
  const idpList = idpAccessors.getIdpList(groupIdpList, groupIdpId);

  let idpStudentIds = new List();
  if (idpList && idpList.size > 0) {
    idpStudentIds = idpList.map((idp) => idp.studentId);
  }
  const membersInCurrentIdp = GroupMembers.getMembersByGroup(state, groupId)
    .filter(({ studentGeneralInfo: { id } }) =>
    idpStudentIds.indexOf(`${id}`) !== - 1);
  const currentMember = GroupMembers.getMemberById(state, studentId);
  return {
    membersInCurrentIdp,
    currentMember,
    shouldHide: ! UiState.getShowNavigationBar(state),
  };
}

StudentSelect.propTypes = {
  currentMember: PropTypes.object,
  membersInCurrentIdp: PropTypes.object.isRequired,
  buildRoute: PropTypes.func.isRequired,
  shouldHide: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(StudentSelect);



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/StudentSelect/index.jsx